import React, { useState, useEffect } from "react";
import { Card, Tab, Nav, Row, Col } from "react-bootstrap";
import Locations from "./location/locations";
import corner4 from "assets/img/illustrations/corner-4.png";
import Background from "components/common/background";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { fetchRoleAndClaims, handleLoadingAndAccess } from "../../../assets/js/common";
import SyncAsperion  from "./asperionSync/syncAsperion";
import GeneralSettings from "./general/generalSettings";
import { getDomainConfig } from "../../../config/domainConfig";
import NotificationSettings from "./notifications/manageNotifications";

const Settings = () => {
  const { t } = useTranslation();
  const [hasAccess, setHasAccess] = useState(null); // null: loading, true: has access, false: no access
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true); 

  useEffect(() => {
    fetchRoleAndClaims({
      navigate,
      claimType: "settings",
      claimValue: "view",
      setHasAccess,
      setIsLoading,
    });
  }, [navigate]);

  const loadingOrRedirect = handleLoadingAndAccess(
    isLoading,
    hasAccess
  );

  if (loadingOrRedirect) {
    return loadingOrRedirect; // Render the loading spinner or handle navigation
  }

  return (
    <>
      <Row className="g-3 mb-3">
        <Col lg={12} xxl={12}>
          <Card className="mb-3 h-100">
            <Background
              image={corner4}
              className="bg-card"
              style={{
                borderTopRightRadius: "0.375rem",
                borderBottomRightRadius: "0.375rem",
              }}
            />
            <Card.Body className="position-relative pe-4 pb-2">
              <Row className="flex-between-center">
                <Col md>
                  <h5 className="mb-2 mb-md-0">{t("settings")}</h5>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="g-3 mb-3 justify-content-center align-items-stretch">
        <Col lg={12} xxl={12}>
          <Card className="mb-3 h-100">
            <Card.Body className="position-relative pe-4 pb-2">
              <Tab.Container defaultActiveKey="locations">
                <Nav variant="tabs">
                   <Nav.Item>
                    <Nav.Link
                      eventKey="general"
                      className="ps-0 cursor-pointer outline-none"
                    >
                      {t("general")}
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="notifications" className="px-2 px-md-3 cursor-pointer outline-none">
                      {t("notifications")}
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      eventKey="locations"
                      className="px-2 px-md-3 ps-0 cursor-pointer outline-none"
                    >
                      {t("branch")}
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      eventKey="anotherTab"
                      className="px-2 px-md-3 cursor-pointer outline-none"
                    >
                      {t("syncAsperion")}
                    </Nav.Link>
                  </Nav.Item>
                </Nav>

                <Tab.Content>
                  {/* General Tab */}
                  <Tab.Pane eventKey="general" className="mt-3">
                    <GeneralSettings />
                  </Tab.Pane>
                  <Tab.Pane eventKey="notifications" className="mt-3">
                    <NotificationSettings />
                  </Tab.Pane>
                  {/* Locations Tab */}
                  <Tab.Pane eventKey="locations" className="mt-3">
                    <Locations />
                  </Tab.Pane>
                  {/* Invoice templates tab */}
                  <Tab.Pane eventKey="anotherTab" className="mt-3">
                    <SyncAsperion />
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Settings;